<section class="ticket-wrap" [class.show]="playedTicket!=null">
  <div class="ticket-content-wrap">
    <section class="ticket-body" *ngIf="playedTicket">
      <article class="ticket-item" *ngFor="let event of playedTicket.events">
        <!-- <ng-container *ngIf="playedTicket.ticketItemEventGroups[orderingGroup.eventId]; let ticketItemGroup"> -->
        <ng-container *ngIf="event.liveScore || event.scores.length !== 0">
          <div class="result-expand" *ngIf="!event.liveScore; else liveResult">
            <div class="row">
              <div class="bet-type-col" >
                <div class="outcome-wrap" *ngFor="let score of event.scores">{{score.scoreGroupName}}</div>
              </div>
              <div class="expand-event"></div>
            </div>

            <div class="row">
              <div class="bet-type-wrap">
                <div class="bet-type-col">
                  <div class="outcome-wrap" *ngFor="let score of event.scores">
                    <span class="result-box" *ngFor="let scorePeriod of score.scorePeriods">
                      <ng-container *ngIf="score.hasHomeAway; else singleScore">
                        <span>{{scorePeriod.homeAwayValue[enumsHomeAway.HOME]}}</span>
                        <span>{{scorePeriod.homeAwayValue[enumsHomeAway.AWAY]}}</span>
                      </ng-container>
                      <ng-template #singleScore>
                          <span>{{scorePeriod.homeAwayValue[enumsHomeAway.NONE]}}</span>
                      </ng-template>
                    </span>
                  </div>
                </div>
              </div>
              <div class="expand-event bcg" (click)="expandEvent(event)" >+</div>
            </div>
          </div>
          <ng-template #liveResult>
            <div class="result-expand">
              <div class="row">
                <div class="bet-type-col" >
                  <div class="outcome-wrap" i18n="My ticket details result@@myTicketsResultsFulltime">Fulltime</div>
                  <div class="outcome-wrap" i18n="My ticket details result@@myTicketsResultsPeriod">Period</div>
                </div>
                <!-- <div class="expand-event"></div> -->
              </div>

              <div class="row">
                <div class="bet-type-wrap">
                  <div class="bet-type-col">
                    <div class="outcome-wrap">
                      <span class="result-box">
                        <span>{{event.liveScore.homeScore}}</span>
                        <span>{{event.liveScore.awayScore}}</span>
                      </span>
                    </div>

                    <div class="outcome-wrap">
                      <span class="result-box">
                        <div class="flex">
                          <span *ngFor="let period of event.liveScore.homeSetScore">{{period}}</span>
                        </div>
                        <div class="flex">
                          <span *ngFor="let period of event.liveScore.awaySetScore">{{period}}</span>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>


        <div class="event-info">
          <div class="team-name-wrap">
            <div class="team-name ticket-info-row">
              <i class="icon-ex-sm s-icon-{{getSportName(event.sportId)}} sportid-{{event.sportId}}"></i>
              <span class="name" *ngIf="event.awayTeam; else eventName">{{event.homeTeam}} - {{event.awayTeam}}</span>
              <ng-template #eventName>
                <span class="name">{{event.homeTeam}}</span>
              </ng-template>
              
              <!-- <span class="live-event" *ngIf="playedTicket.isLive">LIVE</span> -->
              <span class="live-event" *ngIf="event.eventMappingType == eventMappingTypeEnum.SuperBetEvent">{{dynamicTranslations.specialOfferEventsShorcutSuperBet}}</span>
              <span class="live-event" *ngIf="event.eventMappingType == eventMappingTypeEnum.EventOfDay">{{dynamicTranslations.specialOfferEventsShorcutEventOfDay}}</span>
            </div>
            <span class="date-time result" *ngIf="event.liveScore || event.scores.length !== 0; else date" (click)="showResult($event)">
              <ng-container *ngIf="event.liveScore; else prematchResult">
                {{event.liveScore.homeScore}} : {{event.liveScore.awayScore}}
              </ng-container>

              <ng-template #prematchResult>
                <ng-container *ngFor="let score of event.scores">
                  <ng-container *ngIf="score.scoreGroupId === 2">
                    {{score.scorePeriods[0].homeAwayValue[1]}} : {{score.scorePeriods[0].homeAwayValue[2]}}
                  </ng-container>
                </ng-container>
              </ng-template>


              <i class="result-description icon icon-ex-sm s-icon-sporticon-error"></i>
            </span>
            <ng-template #date>
              <span class="date-time">{{event.dateTimeShort}}</span>
            </ng-template>




          </div>
        </div>
        <div class="outcome-main-wrap">
          <ng-container *ngFor="let outcome of event.outcomes">
            <div class="outcome-wrap">
              <div class="outcome-content-wrap">
                <div class="banker" [class.active]="event.system == 'F'" >
                  <!-- <<input type="checkbox" [(ngModel)]="ticketItemGroup.isInBankersGroup" -->
                  <label class="square" [attr.for]="event.id">FIX</label>
                </div>
                <div class="outcome-name-wrap">
                  <div class="bet-type-name">
                    {{outcome.betName}}
                    <ng-container *ngIf="outcome.sbv">
                      -
                      <span class="sbv">
                        <ng-container *ngIf="!outcome.useSbvHandicapPipe">{{outcome.sbv}}</ng-container>
                        <ng-container *ngIf="outcome.useSbvHandicapPipe">{{outcome.sbv | handicapSbv}}</ng-container>
                      </span>
                    </ng-container>
                  </div>
                  <div class="outcome-name">{{outcome.betTypeOutcomeName}}</div>
                </div>
                <div class="outcome {{betOutcomeResultEnum[outcome.status.code] | lowercase}}-outcome">
                  <ng-container>
                    <span class="odd">{{outcome.odd | odd}}</span>
                  </ng-container>
                  <!-- <ng-template #lockedOdd>
                    <div class="icon-wrap">
                      <app-svg-icon iconId="lock"></app-svg-icon>
                    </div>
                  </ng-template> -->
                </div>
              </div>

            </div>
          </ng-container>
          <div class="line"></div>
        </div>
      </article>

      <div class="choose-system" *ngIf="playedTicket.system">
        <div class="title" (click)="this.showSystemOptions = !this.showSystemOptions; $event.stopPropagation(); ">
            <span i18n="System review@@SystemReview">Pregled sistema</span>
            <i class="arrow-down icon icon-chevron-up" [class.closed]="!showSystemOptions"></i>
        </div>
        <div class="system-option" *ngIf="showSystemOptions">
          <!-- <div *ngIf="showSuperBetMsg">{{superBetMsg}}</div> -->
            <!-- <ul class="system-list-wrap">
              <div class="sys-checkbox-wrap">
                <label>
                    <span class="sys-opt">{{playedTicket.system}}</span>
                </label>
              </div>
            </ul> -->
            <ul class="system-list-wrap">
              <ng-container *ngFor="let evCountInCombination of playedTicket.systemEventsInCombination; let i = index;">
                <div class="sys-checkbox-wrap">
                  <label>
                    <span class="sys-opt"><span
                        *ngIf="playedTicket.fixEventsCount>0">F{{playedTicket.fixEventsCount}}+</span>{{evCountInCombination}}/{{playedTicket.systemEventsCount}}</span>
                    <span class="order">{{i+1}}</span>
                  </label>
                </div>
              </ng-container>
              <div class="sys-checkbox-wrap" *ngIf="playedTicket.systemEventsCount == 0">
                <label>
                  <span class="sys-opt">{{playedTicket.fixEventsCount}}/{{playedTicket.fixEventsCount}}</span>
                  <span class="order">1</span>
                </label>
              </div>
            </ul>
        </div>
      </div>
      <!-- </ng-container> -->
      <div class="ticket-info-box white-border" *ngIf="playedTicket.numberOfCombinations > 1">
        <div>
          <span i18n="Number of combinations ticket calculator@@NumberOfCombinatuionsMob">Ukupno kombinacija</span>
          <span>{{playedTicket.numberOfCombinations}}</span>
        </div>

        <div>
          <span i18n="Stake per combination ticket calculator@@StakePerCombinationMob">Ulog po kombinaciji</span>
          <span>{{wagerPerBet | number: displayFormat}} {{CV.CURRENCY}}</span>
        </div>
      </div>
      <ng-container>
        <div class="ticket-info-row">
          <span>
            <span i18n="Total stake on ticket@@TotalStakeWithoutTax">Ulog</span>
            <span *ngIf="taxBeforeStakeDefinitionPercent"> (-{{taxBeforeStakeDefinitionPercent}}% mt)</span>:
          </span>
          <span>{{playedTicket.stake | number: displayFormat}} {{CV.CURRENCY}}</span>
        </div>
        <div class="ticket-info-row">
          <span><span i18n="Win ticket calculator@@Win">Dobitak</span>:</span>
          <span>{{playedTicket.possibleMaxWin | number: displayFormat}} {{CV.CURRENCY}}</span>
        </div>
        <div class="ticket-info-row">
          <span><span i18n="Tax on winnings@@TaxOnWinings">Porez</span>:</span>
          <span>{{playedTicket.taxOnWinning | number: displayFormat}} {{CV.CURRENCY}}</span>
        </div>


        <div class="ticket-info-row highlight" (click)="playedTicket.numberOfCombinations> 1? showPayoutInfos = !showPayoutInfos : showPayoutInfos = showPayoutInfos; $event.stopPropagation();">
          <div>
            <span i18n="Total Odd ticket calculator@@TotalOdd">Tečaj</span>:
            <span class="color"> {{playedTicket.totalOdd | number:'1.2-2'}}</span>
          </div>

          <div class="flex">
            <div class="right-content">
              <span i18n="Possible paout ticket calculator@@PossiblePayout">Ev. isplata</span>:
              <span class="color">{{playedTicket.possiblePayout | number: displayFormat}} {{CV.CURRENCY}}</span>
            </div>
            <div>
              <!-- <i class="arrow-down icon icon-chevron-up" [class.closed]="!showPayoutInfos"></i> -->
              <i *ngIf="playedTicket.numberOfCombinations > 1" class="arrow-down icon" [ngClass]="{'icon-chevron-up': showPayoutInfos, 'icon-chevron-down': !showPayoutInfos }"></i>
            </div>
          </div>
        </div>

        <ng-container *ngIf="showPayoutInfos && playedTicket.numberOfCombinations > 1">
          <div class="ticket-info-row" >
            <span><span i18n="Min possible payout shorted@@MinPossiblePayoutShorted">Min isplata</span>:</span>
            <span>{{playedTicket.possibleMinPayout | number: displayFormat}} {{CV.CURRENCY}}</span>
          </div>
          <div class="ticket-info-row">
            <ng-container i18n="Max possible payout shorted@@MaxPossiblePayoutShorted">Max isplata</ng-container>: <span>
                {{playedTicket.possiblePayout | number:'1.2-2'}} {{CV.CURRENCY}}</span>
          </div>
          <app-winnings-per-hit  *ngIf="possibleWinForNumberOfHits?.length > 1" [possibleWinForNumberOfHits]="possibleWinForNumberOfHits"> </app-winnings-per-hit>
        </ng-container>

        <div class="ticket-info-row p-t" [class.border-top]="showPayoutInfos">
          <div class="ticket-status payin">
            <span><span i18n="Ticket Pay in text@@TicketPayIn">Uplata</span>:</span>
            <span> {{playedTicket.payin | number:'1.2-2'}} {{CV.CURRENCY}}</span>
          </div>

          <span class="ticket-status {{ticketStatusEnum[playedTicket.status.code] | lowercase}}">
            <span><span i18n="Ticket Pay out text@@TicketPayOut">Isplata</span>:</span>
            <span> {{playedTicket.possiblePayout | number:'1.2-2'}} {{CV.CURRENCY}}</span>
          </span>
        </div>

        <!-- <div class="ticket-info-row">
          <span><span i18n="Max possible payout shorted@@MaxPossiblePayoutShorted">Max isplata </span>:</span>
          <span>{{playedTicket.possibleMaxWin | number: displayFormat}} {{CV.CURRENCY}}</span>
        </div> -->

      </ng-container>
    </section>
  </div>
</section>
